import {contracterConstants} from '../../constants'

export const initialState = {
  data: {
    step1: {},
    step2: [],
    step3: [],
    step4: [],
  },
  isOpen: false,
  isType: false,
  guideType: 'individual',
  currentStep: '1',
  isCalled: false,
  isShowItems: false,
  isFailure: false,
  isSend: false,
  itemSeq: '',
}

export default function contracter(state = initialState, action) {
  switch (action.type) {
    /********************
     진행단계 변경
     ********************/
    case contracterConstants.STEP_SAVE:
      return {
        ...state,
        currentStep: action.step,
      }
    /********************
     구매확인서 임시저장
     ********************/
    case contracterConstants.TEMP_SAVE_REQUEST:
      return {
        ...state,
        isCalled: false,
        isFailure: false,
      }
    case contracterConstants.TEMP_SAVE_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          ["step" + state.currentStep] : action.docInfo,
        },
        isCalled: true,
        isFailure: false,
      }
    case contracterConstants.TEMP_SAVE_SUCCESS_LIST:
      return {
        ...state,
        data: {
          ...state.data,
          ["step" + action.step] : action.list,
        },
        isCalled: true,
        isFailure: false,
      }
    case contracterConstants.TEMP_SAVE_FAILURE:
      return {
        ...state,
        isCalled: true,
        isFailure: true,
      }
    case contracterConstants.RESET_CALLED:
      return {
      ...state,
        isCalled: action.called,
      }
    case contracterConstants.SET_STEP_DATA:
      return {
        ...state,
        data : {
          ...state.data,
          ["step" + action.step] : action.stepInfo
        },
      }
    /********************
     구매확인서 문서번호 채번
     ********************/
    case contracterConstants.GET_DOCNUM_REQUEST :
      return {
        ...state
      }
    case contracterConstants.GET_DOCNUM_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          step1: action.response.data?.payload,
        },
      }
    case contracterConstants.GET_DOCNUM_FAILURE:
      return {
        ...state,
        data: null,
      }
    /********************
     구매확인서 저장정보 조회
     ********************/
    case contracterConstants.GET_CONFIRMATION_REQUEST :
      return {
        ...state
      }
    case contracterConstants.GET_CONFIRMATION_SUCCESS:
      let obj = action.response.data?.payload;
      return {
        ...state,
        data: {
          step1: obj?.crtIssueMasterDto ? obj?.crtIssueMasterDto : {},
          step2: obj?.crtConfirmationItemDtoList ? obj?.crtConfirmationItemDtoList : [],
          step3: obj?.crtConfirmationFileDtoList ? obj?.crtConfirmationFileDtoList : [],
          step4: obj?.crtConfirmationTaxDtoList ? obj?.crtConfirmationTaxDtoList : [],
        },
      }
    case contracterConstants.GET_CONFIRMATION_FAILURE:
      return {
        ...state,
        data: null,
      }
    /********************
     구매확인서 임시저장정보 삭제
     ********************/
    case contracterConstants.TEMP_DELETE_REQUEST :
      return {
        ...state,
        isDelete: false,
      }
    case contracterConstants.TEMP_DELETE_SUCCESS:
      return {
        ...state,
        isDelete: true,
      }
    case contracterConstants.TEMP_DELETE_FAILURE:
      return {
        ...state,
        data: null,
        isDelete: false,
      }
    /********************
     구매확인서 발급신청
     ********************/
    case contracterConstants.ISSUE_REQUEST :
      return {
        ...state,
        isSend:false,
      }
    case contracterConstants.ISSUE_SUCCESS:
      return {
        ...state,
        isSend:true,
      }
    case contracterConstants.ISSUE_FAILURE:
      return {
        ...state,
        isSend:false,
      }
    /**
     * 팝업 화면 표시용
     */
    case contracterConstants.CONTRACTER_REQUEST:
      return {
        ...state,
        isOpen: !state.isOpen
      }
    case contracterConstants.SHOW_POPUP_ITEMS:
      return {
        isShowItems: action.isShow,
        itemSeq: '',
      }
    case contracterConstants.SELECT_POPUP_ITEMS:
      return {
        itemSeq: action.itemSeq,
        isShowItems: false,
      }
    case contracterConstants.CONTRACTER_SUCCESS:
      return {
        ...state,
        isType: !state.isType
      }
    case contracterConstants.CONTRACTER_TOGGLE_TYPE:
      return {
        ...state,
        isType: !state.isType
      }
    case contracterConstants.CONTRACTER_CLOSE:
      return {
        ...state,
        isOpen: !state.isOpen
      }
    case contracterConstants.CONTRACTER_GUIDE_TYPE:
      return {
        ...state,
        guideType: action.guideType
      }
    default:
      return state
  }
}
